import { CircularProgress, FormControl, TextField } from '@material-ui/core';
import Autocomplete, {
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  AutocompleteRenderOptionState,
} from '@material-ui/lab/Autocomplete';
import React, { useState } from 'react';

interface AutoCompleteProps {
  options: unknown[];
  loading?: boolean;
  disabled?: boolean;
  placeholder?: string;
  multiple?: boolean;
  limitTags?: number;
  value: any;
  onChange: (
    event: React.ChangeEvent<{}>,
    value: any,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<unknown> | undefined,
  ) => void;
  renderOption?: (
    option: any,
    state: AutocompleteRenderOptionState,
  ) => React.ReactNode;
  renderTags?: (value: any[]) => React.ReactNode;
  getOptionLabel?: (option: any) => string;
  getOptionSelected?: (option: any, value: any) => boolean;
  getOptionDisabled?: (option: any) => boolean;
}

const AutoComplete: React.FC<AutoCompleteProps> = ({ ...props }) => {
  const {
    placeholder,
    disabled,
    loading,
    multiple,
    limitTags,
    value,
    getOptionDisabled,
  } = props;
  const [openAutoComplete, setOpenAutoComplete] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleInputValueChange = (event: React.ChangeEvent<{}>, value: any) => {
    setInputValue(value);
  };

  return (
    <FormControl fullWidth>
      <Autocomplete
        clearOnBlur={false}
        onInputChange={handleInputValueChange}
        open={openAutoComplete}
        inputValue={inputValue}
        multiple={multiple}
        limitTags={limitTags}
        value={value}
        getOptionDisabled={getOptionDisabled}
        disableCloseOnSelect={multiple || false}
        ListboxProps={{
          style: { maxHeight: '300px' },
          position: 'bottom-start',
        }}
        onOpen={() => {
          setOpenAutoComplete(true);
        }}
        onClose={() => {
          setOpenAutoComplete(false);
        }}
        renderInput={params => (
          <TextField
            {...params}
            placeholder={inputValue.length === 0 ? placeholder : ''}
            fullWidth
            disabled={disabled}
            style={{ maxHeight: 200, overflowY: 'auto' }}
            color="primary"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="primary" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        {...props}
      />
    </FormControl>
  );
};

export default AutoComplete;
